class LoadMoreProducts extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.grid = document.getElementById('product-grid');
    this.step = parseInt(this.dataset.step, 10) || 3;
    this.visibleCount = parseInt(this.dataset.initial, 10) || 6;
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.button.addEventListener('click', this.onClick);
    this.applyVisibility();
  }

  getItems() {
    return this.grid ? Array.from(this.grid.children) : [];
  }

  applyVisibility() {
    const items = this.getItems();
    items.forEach((item, index) => {
      item.hidden = index >= this.visibleCount;
    });
    this.updateButtonVisibility(items.length);
  }

  updateButtonVisibility(totalItems) {
    const hasMoreLocally = this.visibleCount < totalItems;
    const hasMoreRemotely = Boolean(this.button.dataset.nextUrl);
    this.hidden = !(hasMoreLocally || hasMoreRemotely);
  }

  onClick() {
    if (this.button.disabled) return;

    const totalItems = this.getItems().length;
    if (this.visibleCount < totalItems) {
      this.visibleCount += this.step;
      this.applyVisibility();
      return;
    }

    const url = this.button.dataset.nextUrl;
    if (!url) {
      this.hidden = true;
      return;
    }

    this.button.disabled = true;
    this.button.classList.add('loading');
    this.button.querySelector('.loading__spinner').classList.remove('hidden');

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newGrid = html.getElementById('product-grid');

        if (newGrid && this.grid) {
          Array.from(newGrid.children).forEach((item) => {
            item.hidden = true;
            this.grid.appendChild(item);
          });
        }

        const newButton = html.querySelector('load-more-products button');
        this.button.dataset.nextUrl = newButton && newButton.dataset.nextUrl ? newButton.dataset.nextUrl : '';

        this.visibleCount += this.step;
        this.applyVisibility();
      })
      .catch(() => {
        this.button.dataset.nextUrl = '';
        this.applyVisibility();
      })
      .finally(() => {
        this.button.disabled = false;
        this.button.classList.remove('loading');
        this.button.querySelector('.loading__spinner').classList.add('hidden');
      });
  }
}

customElements.define('load-more-products', LoadMoreProducts);
